import { KeycloakConstants } from "./constants";

export const setLogIn = (
    logged: boolean,
    roles: Array<string>,
    keycloak: Keycloak.KeycloakInstance | null
) => {
    const token: string | null = keycloak?.token ? keycloak?.token : null;
    const tokenParsed: any = keycloak?.tokenParsed;
    const userName: string = tokenParsed?.name ?? tokenParsed?.user_name;
    const sub = tokenParsed.sub;
    const email = tokenParsed.email;
    const name = tokenParsed.name;

    const keycloakInfo = {
        logged: logged,
        userRoles: roles,
        userName: userName,
        token: token,
        sub: sub,
        name: name,
        email: email,
    };
    return {
        type: KeycloakConstants.SET_LOG_IN,
        payload: keycloakInfo,
    };
};

export const setLogOut = () => {
    return {
        type: KeycloakConstants.SET_LOG_OUT,
    };
};

